module.exports = __webpack_public_path__ + "static/media/icon_payment_successful.04e4d9c9.svg";